import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IProjectEvaluator } from "../../project/core/_models";
import { getProjectEvaluationStatusClass } from "../../../../utils/config";

type EvaluatorsAvatarProps = {
  evaluators: IProjectEvaluator[];
  maxVisible?: number;
  onClick?: (evaluator: IProjectEvaluator) => void;
};

const EvaluatorsAvatar: React.FC<EvaluatorsAvatarProps> = ({ evaluators, maxVisible = 3, onClick }) => {
  const visibleItems = useMemo(
    () => evaluators.slice(0, maxVisible),
    [evaluators, maxVisible]
  );
  const extraCount = Math.max(0, evaluators.length - maxVisible);
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {visibleItems.map((evaluator,idx) => {

        const bgGradientClass = getProjectEvaluationStatusClass(evaluator.eval_status);

        const fullName = `${evaluator.first_name} ${evaluator.last_name}`.trim();
        const tooltip = (
          <Tooltip className="custom-tooltip">
            Name : <strong>{fullName}</strong>
            <br />
            Evaluation Status : <strong>{evaluator.eval_status}</strong>
        
            {evaluator.eval_status?.toLowerCase() === "completed" && (
              <>
                <br />
                Score : <strong>{evaluator.avg_score}%</strong>
              </>
            )}
          </Tooltip>
        );
        return (
          <OverlayTrigger
            key={evaluator.user_id}
            placement="top"
            overlay={tooltip}
          >
            <div
              className={`text-white overlaped-circle ${bgGradientClass} fs-6 fw-bold d-flex justify-content-center align-items-center rounded-circle shadow-sm cursor-pointer`}
              style={{
                userSelect: "none",
                marginLeft: idx === 0 ? 0 : -10,
                zIndex: evaluators.length - idx,

              }}
              onClick={() => onClick?.(evaluator)}
            >
              {evaluator.initials}
            </div>
          </OverlayTrigger>
        );
      })}

      {extraCount > 0 && (
        <div
          className="text-gray-700 bg-secondary fs-6 fw-bold d-flex justify-content-center align-items-center rounded-circle shadow-sm cursor-pointer"
          style={{
            width: 32,
            height: 32,
            userSelect: "none",
            zIndex: 0,
          }}
        >
          +{extraCount}
        </div>
      )}
    </div>
  );
};

export default EvaluatorsAvatar;